import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CalibracionComponent } from './calibracion/calibracion.component';
import { CalificacionComponent } from './calificacion/calificacion.component';
import { TiendaComponent } from './tienda/tienda.component';
import { ContactoComponent } from './contacto/contacto.component';
import { TipoComponent } from './calibracion/tipo/tipo.component';
import { ProductoComponent } from './tienda/producto/producto.component';
import { CapacitacionComponent } from './capacitacion/capacitacion.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CalibracionComponent,
    CalificacionComponent,
    TiendaComponent,
    ContactoComponent,
    TipoComponent,
    ProductoComponent,
    CapacitacionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
